import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

// const userId = 'H8XTiCvnxOWojohm2DewzlBxrjG2';
// const newTradeLog = {
//   tradeId: 'sd7f7f8d57fd',
//   closingPrice: '15.00',
//   openingPrice: '10.00',
//   stopLoss: '9.00',
//   takeProfit: '15.00',
//   date: '13',
//   month: 'October',
//   year: '2021',
//   notes: '',
//   numberOfShares: 2,
//   ticker: 'GOOGL',
// };
// const updatedTradeLog = {
//   tradeId: 'sd7f7f8d57fd',
//   closingPrice: '15.00',
//   openingPrice: '10.00',
//   stopLoss: '9.00',
//   takeProfit: '15.00',
//   date: '13',
//   month: 'October',
//   year: '2021',
//   notes: '',
//   numberOfShares: 2,
//   ticker: 'LOL',
// };
// const tradeLogId = 'sd7f7f8d57fd';


// fetchAllTradesByUserId('H8XTiCvnxOWojohm2DewzlBxrjG2');
// createNewTradeLog(newTradeLog, userId);
// deleteTradeLog(tradeLogId, userId);
// updateTradeLog(tradeLogId, updatedTradeLog, userId);

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
